import React from 'react';
import PropTypes from 'prop-types';
import {Modal} from 'antd';

import VideoPage from '@/page/app/MediaPage/pages/VideoPage';

SelectVideoModal.propTypes = {
    visible: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
};

function SelectVideoModal({visible, onClose, onSelect}) {
    function onItemChecked(record) {
        onSelect(record);
        onClose();
    }

    return (
        <Modal
            visible={visible}
            title="选择视频"
            width={1500}
            destroyOnClose
            onCancel={onClose}
            okButtonProps={{style: {display: 'none'}}}
        >
            <VideoPage editable={false} onItemChecked={onItemChecked} />
        </Modal>
    );
}

export default SelectVideoModal;
